<template>
  <div class="overlay">
    <div class="overlay_inner channel_list">
      <p class="note">{{data['title']}}</p>
      <div class="recipients_list">
        <table>
          <tbody>
          <tr v-if="summedList.hasOwnProperty('all')">
            <td class="first_data"><strong v-translate>Globální nastavení</strong></td>
            <td class="last_data" :title="!isSingleValue ?$gettext('Živě, timeshift / catchup, PVR'): ''"><strong>{{getTextValue(summedList['all'])}}</strong></td>
          </tr>
          <tr v-for="(item, key) in summedList">
            <td v-if="key !== 'all'" class="first_data">{{getChannelNamesFromIds(item.channelIds)}}</td>
            <td v-if="key !== 'all'" class="last_data"
                :title="!isSingleValue ?$gettext('Živě, timeshift / catchup, PVR'): ''">{{getTextValue(item)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <a
          class="btn btn_action btn_close"
          :title="'Zavřít' | translate"
          @click.stop.prevent="emitClose"
          v-translate>Zavřít
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "ServiceAdvertisementPopup",
  props: {
    data: Object,
    channelList: Array,
  },
  computed: {
    summedList(){
      if(!this.isSingleValue){
        return this.getSummedLinearNonlinearData(this.data.data);
      }else{
        return this.getSummedSingleValueData(this.data.data);
      }
    },
    summedChannels(){
      let result = {};
      this.channelList.forEach((item) => {
        result[item.id] = item.name;
      });

      return result;
    },
    isSingleValue(){
      return !(this.data.data.hasOwnProperty('linear') && this.data.data.hasOwnProperty('nonlinear'))
    },
  },
  methods: {
    emitClose() {
      this.$emit('close')
    },
    getSummedSingleValueData(data){
      let result = {};
      for (const [key, value] of Object.entries(data.value)){
        if(key === 'all'){
          result['all'] = {
            'value': value,
          }
        }else{
          const composedKey = value;
          if(result.hasOwnProperty(composedKey)){
            result[composedKey]["channelIds"].push(key);
          }else{
            result[composedKey] = {
              'channelIds': [key],
              'value': value,
            }
          }
        }
      }

      return result;
    },
    getSummedLinearNonlinearData(data){
      let result = {};
      for (const [key, value] of Object.entries(data.linear)){
        if(key === 'all'){
          result['all'] = {
            'linear': value,
            'nonlinear': '-'
          }
        }else{
          let composedKey = "";
          if(data.nonlinear.hasOwnProperty(key)){
            composedKey = value + "-"+data.nonlinear[key];
          }else{
            composedKey = value + "-";
          }
          if(result.hasOwnProperty(composedKey)){
            if(!result[composedKey]['channelIds'].includes(key)){
              result[composedKey]['channelIds'].push(key);
            }
          }else{
            result[composedKey] = {
              'channelIds': [key],
              'linear': value,
              'nonlinear': data.nonlinear.hasOwnProperty(key) ? data.nonlinear[key] : '-'
            }
          }
        }
      }


      for (const [key, value] of Object.entries(data.nonlinear)){
        if(key === 'all'){
          if(result.hasOwnProperty('all')){
            result['all']['nonlinear'] = value;
          }else{
            result['all'] = {
              'linear': '-',
              'nonlinear': value
            }
          }
        }else{
          let composedKey = "";
          if(data.linear.hasOwnProperty(key)){
            composedKey = data.linear[key] + "-"+value;
          }else{
            composedKey = "-" + value;
          }
          if(result.hasOwnProperty(composedKey)){
            if(!result[composedKey]['channelIds'].includes(key)){
              result[composedKey]['channelIds'].push(key);
            }
          }else{
            result[composedKey] = {
              'channelIds': [key],
              'linear': data.linear.hasOwnProperty(key) ? data.linear[key] : '-',
              'nonlinear': value,
            }
          }
        }
      }

      return result;
    },

    getChannelNamesFromIds(ids){
      let result = [];
      ids.forEach((item) => {
        result.push(this.summedChannels[item]);
      });
      return result.join(', ');
    },
    getTextValue(item){
      if(item.hasOwnProperty('linear') && item.hasOwnProperty('nonlinear')){
        return this.getTextFromSingleValueByType(item.linear, this.data.type)
            + " / "
            + this.getTextFromSingleValueByType(item.nonlinear, this.data.type);
      }else{
        return this.getTextFromSingleValueByType(item.value, this.data.type)
      }
    },
    getTextFromSingleValueByType(value, type){
      if(type === 'seconds'){
        return this.getSecondsText(value);
      }else if(type ==='boolean'){
        return this.getBooleanText(value);
      }
    },
    getSecondsText(value) {
      if (value != '-') {
        if (value < 1){
          return value + ' ' + this.$gettext("vteřin");
        }else if (value < 2) {
          return value + ' ' + this.$gettext("vteřina");
        } else if (value < 5) {
          return value + ' ' + this.$gettext("vteřiny");
        } else {
          return value + ' ' + this.$gettext("vteřin");
        }
      } else {
        return '–';
      }
    },
    getBooleanText(value) {
      if (value === true) {
        return this.$gettext("Ano");
      } else if (value === false) {
        return this.$gettext("Ne");
      } else{
        return '–';
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServiceAdvertisementPopup.vue